import React from "react";
import TextField from '@material-ui/core/TextField';
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import {Link} from "@material-ui/core";
import {showAlert} from "../../store/actions/common";
import {domain} from "../../config/routes";

const styles = theme => {
    return {
        textField: {
            width: '80%',
            marginTop: '40px',
            marginRight: '40px',
            marginLeft: '40px',
        },
        form: {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column'
        },
        button: {
            color: '#fff',
            marginTop: '40px'
        }
    }

}

class ResetForm extends React.Component {
    constructor() {
        super();
        this.state = {
            'email': '',
            'password': '',
            errorEmail: ''
        }
    }

    handleChange = (e) => {
        const {name, value} = e.target;
        this.setState({[name] : value})
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onSubmit(this.state);
    }

    handleForgot = (e) => {
        if (!this.state.email) {
            this.props.dispatch(showAlert('Ошибка', 'Заполнете поле почты'));
            return ;
        }
        else {

        }
    }

    render() {
        const {classes} = this.props;
        return (
            <form className={classes.form} method={'post'} action={domain + '/api/confirm-new-password'}>

                <TextField
                    className={this.props.classes.textField}
                    label={'Пароль'}
                    name={'password'}
                    variant={'outlined'}
                    type={'password'}
                />


                <TextField
                    className={this.props.classes.textField}
                    label={'Повторите пароль'}
                    name={'password_confirmation'}
                    variant={'outlined'}
                    type={'password'}
                />

                <input hidden={true} type={'hidden'} name={'token'} value={this.props.token}/>
                <input hidden={true} type={'hidden'} name={'email'} value={this.props.email}/>

                <Button variant={'contained'} color={'primary'} className={classes.button} type={'submit'}>
                    Отправить
                </Button>

            </form>
        );
    }
}

export default withStyles(styles)(ResetForm)